import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseStudentLoginHistories } from '@/api/responses/studentLoginHistories'

export namespace StudentLoginHistoriesApi {
  /**
   * ログイン履歴一覧取得(MAX:10件)
   *
   * @returns ログイン日一覧
   */
  export async function getList(): Promise<ApiResponseStudentLoginHistories> {
    return await ApiBase.get('studentLoginHistories/list')
  }
}
